import { createFileRoute } from "@tanstack/react-router"
import { projectsViewStaticData } from "src/views/ProjectsView/constants"
import { ProjectsView } from "src/views/ProjectsView/ProjectsView"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/projects/")({
	component: ProjectsView,
	staticData: projectsViewStaticData,
})
